import React from 'react';
import { Heading, Text } from '@fiverr-private/typography';
import { Stack } from '@fiverr-private/layout_components';
import { I18n } from '@fiverr-private/i18n-react';
import ErrorSVG from './ErrorSVG';

export const ErrorState = () => (
  <Stack gap="8" direction="column" alignItems="center" padding="16">
    <ErrorSVG />
    <Stack direction="column" alignItems="center">
      <Heading size={{ default: 'h_xs', md: 'h_sm' }}>
        <I18n k="brief_preview_drawer.fetch_error.title" />
      </Heading>
      <Text size={{ default: 'b_sm', md: 'b_md' }}>
        <I18n k="brief_preview_drawer.fetch_error.message" />
      </Text>
    </Stack>
  </Stack>
);
